module.exports = __webpack_public_path__ + "img/13-detail.a739b801.webp";